export default __webpack_public_path__ + "static/media/add-fee-disabled.b7bd3599.svg";